export const localStorageKeys = {
  KEY_TOKEN: "token",
  KEY_USER: "user",
  KEY_PERMISSION: "permission",
  LANG: "lang",
};
